import type { FaireProductEntity } from "../../entity_types/product";

export const p_4ymksyyeuu: FaireProductEntity = {
  token: "p_4ymksyyeuu",
  type: "product",
  name: "RARE Covellite Crystal Tumbled Stones, Peru",
  brandToken: "b_rt8fmuccyw",
  brandName: "Caspar Curiosities",
  imageUrl:
    "https://cdn.faire.com/fastly/51ba321686690eae1b9a435eb56c5af5d12912cffb527d5af91dda82ac5101f8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ea7d9348abcf8d1f2ac752a8d4a3d5a77d06c2a52914c0fbce570dbc8db92b60.jpeg",
    "https://cdn.faire.com/fastly/4aab9ee4899df3f175ecfa78ad4e8c3941eddb36e5cba23caa3428e436b9732d.jpeg",
    "https://cdn.faire.com/fastly/7c7beaff7736d36f53a76a631b89eef4986c8ca3d7cad71586e751f7a5ad58b8.jpeg",
    "https://cdn.faire.com/fastly/46155c341bf40675b60e75261e13387a0e6c978e1e5f0fec55780a51f2b091d9.jpeg",
  ],
  priceDollars: 10.5,
  description:
    "For your consideration are these beautiful and super rare Covellite and Pyrite crystal tumbled stones from Peru. These pieces are GORGEOUS and are sold by weight.\n\nCovellite is a stone of Magic. It aids in the development of intuition, psychic abilities and personal magic. Helps one find Spirit Guides and remember past lives. A great stone for lucid dreaming. Stimulates rebirth, creativity and optimism. An energetically harmonizing and grounding stone that can promote manifestation of miracles.\nChakra: Third Eye and Crown ",
  tags: [],
  msrpDollars: 21,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:58.226Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
